export enum UserScopes {
  Interview,
  Settings,
  Users,
  Candidates,
}
